import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Clientes } from "../../Clientes/Clientes";
import { Personal } from "../../Personal/Personal";
import { Productos } from "../../Productos/Productos";
import { Servicios } from "../../Servicios/Servicios";
import { Tiendas } from "../../Tiendas/Tiendas";

const columns = () =>
(
    {
        vc_servicios: new EntityColumn<string[]>({ name: 'vc_servicios', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Servicios', isArray: true }),
        vc_tiendas: new EntityColumn<string[]>({ name: 'vc_tiendas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tiendas', isArray: true }),
        vc_productos: new EntityColumn<string[]>({ name: 'vc_productos', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Productos', isArray: true }),
        vc_clientes: new EntityColumn<string[]>({ name: 'vc_clientes', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes', isArray: true }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Servicios(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Productos(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
    }
)

export class DatosServiciosAutorizacionFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('DatosServiciosAutorizacionFilters');
    }
}